{
  "actions": "Acties",
  "actionsAvailable": "Acties beschikbaar.",
  "clearSelection": "Selectie wissen",
  "selected": "{count, plural, =0 {Niets geselecteerd} other {# geselecteerd}}",
  "selectedAll": "Alles geselecteerd"
}
